// extracted by mini-css-extract-plugin
export default {"map_container":"places_map_container__0VqWB","image_container":"places_image_container__u42RL"};